import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const DeleteJobSynonymModalContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "DeleteJobSynonymModalContainer" */
      './DeleteJobSynonymModalContainer'
    ),
  loading: LoadingModal,
});
